export default "__VITE_ASSET__DpNu$$xi__"